import {
  mdiCheckboxMarkedCircleOutline,
  mdiMagnify,
  mdiMenuDown,
  mdiChevronUp,
  mdiChevronDown,
  mdiReply,
  mdiCircleOutline,
  mdiBlockHelper,
  mdiCloseCircle,
  mdiAlertOutline,
  mdiHelpCircleOutline,
  mdiEmoticonHappy,
  mdiEmoticonHappyOutline,
  mdiHeart,
  mdiHeartOutline,
  mdiHeartHalf,
} from '@mdi/js';

export const icons = {
  checkboxMarkedCircleOutline: mdiCheckboxMarkedCircleOutline,
  magnify: mdiMagnify,
  menuDown: mdiMenuDown,
  chevronUp: mdiChevronUp,
  chevronDown: mdiChevronDown,
  reply: mdiReply,
  circleOutline: mdiCircleOutline,
  blockHelper: mdiBlockHelper,
  closeCircle: mdiCloseCircle,
  alertOutline: mdiAlertOutline,
  helpCircleOutline: mdiHelpCircleOutline,
  emoticonHappy: mdiEmoticonHappy,
  emoticonHappyOutline: mdiEmoticonHappyOutline,
  heart: mdiHeart,
  heartOutline: mdiHeartOutline,
  heartHalf: mdiHeartHalf,
};
